import React, { forwardRef, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react"
import normalizeText from "../../utils/normalizeText";

const SelectCtrlMenu = forwardRef(({showSelectCtrl, handleCloseSelectCtrlMenu, handleDeleteControlFromSelectMenu, optionsCtrls = [], controles, editingClick, ctrlSelected}, ref) => {

    const [filter, setFilter] = useState('');
    const [pos, setPos] = useState({x:null, y:null});

    const menuRef = useRef(null);

    const optionsFiltered = useMemo(()=> optionsCtrls?.filter(c => {
        return filter == '' || normalizeText(c.name || '').includes(normalizeText(filter || '')) || normalizeText(c.value || '').includes(normalizeText(filter || '')) || normalizeText(c.descrp || '').includes(normalizeText(filter || ''))
    }),[optionsCtrls, filter])
    
    useEffect(()=>{
        const menu = menuRef.current;
        if(!menu || !showSelectCtrl.x) return;

        const { innerHeight, innerWidth } = window;
        const rect = menu.getBoundingClientRect();

        let newX = showSelectCtrl.x;
        let newY = showSelectCtrl.y;

        if(newX + rect.width > innerWidth){
            newX = newX - rect.width;
        }

        setPos({x: newX, y: newY});

    },[showSelectCtrl]);

    return <div ref={menuRef} className="showSelectCtrlContainer" style={{top: pos?.y ?? -9999, left: pos?.x ?? -9999, zIndex:1000}}>
        <div className="filterCtrlsMenuContainer">
            <input className="inputFilterCtrlsMenu" onChange={(e) => setFilter(e.target.value)} value={filter}/>
            <button className="minimizarBtn" onClick={handleCloseSelectCtrlMenu}>X</button>
        </div>
        <div className="ctrlsContainer">
            <label onClick={handleDeleteControlFromSelectMenu} className="labelCtrlToSelect Delete">Eliminar Control</label>
            {optionsFiltered?.map(c => <label style={{zIndex:1001, ...(controles.some(cP => (cP.x == editingClick?.x && cP.value == c.value)) && {backgroundColor:'darkgreen'})}} className="labelCtrlToSelect" onClick={e => {e.preventDefault(); e.stopPropagation(); ctrlSelected(c)}}>{c.name}</label>)}
        </div>
    </div>

})

export default SelectCtrlMenu